import * as React from 'react';
import { History } from 'history';
import Model from './personalinfo-model';
import BaseChecklist from '../base/base-checklist.component';

interface IProps { 
  history: History;
  caption?: string;
  personalinfotypeType?: string;
  onLoad?: (data: any) => void;
  currentId: any;
  readOnly?: boolean;
  selectedOnly?: boolean;
  disableBackButton? : boolean;
  disableCard? : boolean;
}

interface IState {
}

export default class PersonalinfoChecklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }



  public render(): React.ReactNode {
    return (
      <BaseChecklist history={this.props.history} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.personalinfotypeType)} model={Model} currentId={this.props.currentId} onLoad={this.props.onLoad} readOnly={this.props.readOnly} selectedOnly={this.props.selectedOnly} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
